import { Component, OnInit, Input, ViewEncapsulation, HostListener } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  trigger,
  state,
  style,
  transition,
  animate
} from '@angular/animations';

@Component({
  selector: 'app-media-viewer',
  templateUrl: './media-viewer.component.html',
  styleUrls: ['./media-viewer.component.css'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('visibility-item', [
      state('in', style({
        opacity: '1',
      })),
      state('out', style({
        opacity: '0'
      })),
      transition('in => out', animate('200ms')),
      transition('out => in', animate('200ms'))
    ])
  ]
})
export class MediaViewerComponent implements OnInit {

  @Input() items: any[];
  @Input() currentItem: number;

  loading = true;
  status = 'in';
  screenHeight: number;
  screenWidth: number;
  margin = 80;

  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    this.screenSize();
  }

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {
    this.screenSize();
  }

  screenSize() {
    this.screenHeight = window.innerHeight - this.margin;
    this.screenWidth = window.innerWidth;
  }

  nextItem(event: any) {
    this.loading = true;
    this.status = 'out';
    setTimeout(() => {
      if (this.items[this.currentItem + 1]) {
        this.currentItem++;
      } else {
        this.currentItem = 0;
      }
    }, 200);
  }

  previousItem(event: any) {
    this.loading = true;
    this.status = 'out';

    setTimeout(() => {
      if (this.currentItem === 0) {
        this.currentItem = this.items.length - 1;
      } else {
        this.currentItem--;
      }
    }, 200);
  }

  finishLoad() {
    this.loading = false;
    this.status = 'in';
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/utils/media-viewer/media-viewer.component.ts